import { render, staticRenderFns } from "./PostHistories.vue?vue&type=template&id=625e5fb8&scoped=true"
import script from "./PostHistories.vue?vue&type=script&lang=js"
export * from "./PostHistories.vue?vue&type=script&lang=js"
import style0 from "./PostHistories.vue?vue&type=style&index=0&id=625e5fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e5fb8",
  null
  
)

export default component.exports